var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social-app" },
    [
      _c(
        "instagram-feed",
        {
          attrs: {
            token: "359214030.6138ab1.baa81cff146b4bab9ba1014b4acb4c99",
            profile: "visitsouthernhighlands",
            count: 4,
            displayLoadMore: false
          }
        },
        [
          _c("template", { slot: "header" }, [
            _c("h2", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.instagram.com/visitsouthernhighlands",
                    target: "_blank",
                    title: "Facebook"
                  }
                },
                [_vm._v("Instagram")]
              )
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "youtube-feed",
        {
          attrs: {
            token: "AIzaSyAT45yvJJ055sX8rnDw70LL4cer1cDIJ8g",
            profile: "Thesouthernhighlands",
            count: 4,
            displayLoadMore: false
          }
        },
        [
          _c("template", { slot: "header" }, [
            _c("h2", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.youtube.com/channel/UC0Cxai2z7ntgnjGhiYa998g",
                    target: "_blank",
                    title: "YouTube"
                  }
                },
                [_vm._v("Youtube")]
              )
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "facebook-feed",
        {
          attrs: {
            profile: "DestinationSouthernHighlands",
            token:
              "EAAEWFcDpeGABANFQRkbu5ZCt1Fsgbvzo3J55RLp7eQIZCqWOqNHvWEniZAa3sjgj8aGKQUbxhIh7cOaEqrbgUxKKLprbtBI7U9jfoxYs91ZAXJ2WjtL4JTrqZB4v5kHT9FMyKW71el0c9kL3nUeWWqGbn7aYNFDLUCD09hQsAjanppJXMQBiPpYeUntsxjqMZD",
            count: 4,
            displayLoadMore: false,
            displayDescription: false
          }
        },
        [
          _c("template", { slot: "header" }, [
            _c("h2", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.facebook.com/DestinationSouthernHighlands",
                    target: "_blank",
                    title: "Facebook"
                  }
                },
                [_vm._v("Facebook")]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/SocialApp.vue?vue&type=template&id=af09f520&
// module id = 124
// module chunks = 7